var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 0.707107C17.6834 0.316582 18.3166 0.316583 18.7071 0.707107C19.0976 1.09763 19.0976 1.7308 18.7071 2.12132L9.70711 11.1213C9.31658 11.5118 8.68342 11.5118 8.29289 11.1213C7.90237 10.7308 7.90237 10.0976 8.29289 9.70711L17.2929 0.707107Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.41418H13C12.4477 2.41418 12 1.96647 12 1.41418C12 0.8619 12.4477 0.414185 13 0.414185H18C18.5523 0.414185 19 0.8619 19 1.41418V6.41418C19 6.96647 18.5523 7.41418 18 7.41418C17.4477 7.41418 17 6.96647 17 6.41418V2.41418Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.9142C15 10.3619 15.4477 9.91419 16 9.91419C16.5523 9.91419 17 10.3619 17 10.9142V16.5392C17 18.127 15.7128 19.4142 14.125 19.4142H2.875C1.28718 19.4142 0 18.127 0 16.5392L2.38419e-06 5.28918C2.38419e-06 3.70136 1.28718 2.41418 2.875 2.41418C6.90694 2.41419 6.90694 2.41419 8.96875 2.41419C9.52104 2.41419 9.96875 2.8619 9.96875 3.41419C9.96875 3.96647 9.52104 4.41419 8.96875 4.41419C6.90694 4.41419 6.90694 4.41419 2.875 4.41418C2.39175 4.41418 2 4.80593 2 5.28918L2 16.5392C2 17.0224 2.39175 17.4142 2.875 17.4142H14.125C14.6083 17.4142 15 17.0224 15 16.5392V10.9142Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon_export.17a199c591e1827af2f9b1e03794c6ac.svg";
export { ForwardRef as ReactComponent };